module.exports = __webpack_public_path__ + "img/step-2.0a3e97a9.svg";